// extracted by mini-css-extract-plugin
module.exports = {"carrousel":"Carrousel_carrousel__ouYgY","slider":"Carrousel_slider__sHoSp","chevronLeft":"Carrousel_chevronLeft__qUoex","chevronRight":"Carrousel_chevronRight__rkiil"};